import * as EditorTypeAll from '../tinymce.d';
import signatureIcon from './image/signature.svg';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const Signature = ({ editorInstance }: Props) => {
  const signatureAction = () => {
    // 插入签名的逻辑
    const signatureHtml = '<div class="signature">{{signature}}</div>';
    editorInstance.insertContent(signatureHtml);
  };

  return (
    <div 
      className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" 
      onClick={signatureAction}
    >
      <img width="18px" height="18px" src={signatureIcon} alt="Signature" />
    </div>
  );
};

export default Signature;
